import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, RotateCcw, Wrench, Camera } from "lucide-react";

const FIX_WINDOW_MS = 60 * 60 * 1000;

// Drivers may fix closed stops while the route is open, or for 60 min after it auto-completed.
export const fixDeadline = (route) => {
  if (!route) return null;
  if (route.status === "in_progress" || route.status === "paused") return Infinity;
  if (route.status === "completed" && route.auto_completed && route.completed_at) {
    const until = new Date(route.completed_at).getTime() + FIX_WINDOW_MS;
    return until > Date.now() ? until : null;
  }
  return null;
};

export function StopFixActions({ stop, onDeliver, onFail, onReopen }) {
  const [open, setOpen] = useState(false);
  const id = stop.order_id;
  const delivered = stop.status === "delivered";

  if (!open) {
    return (
      <Button
        variant="outline"
        onClick={() => setOpen(true)}
        className="mt-3 w-full h-10 rounded-full border-dashed"
        data-testid={`fix-stop-${id}`}
      >
        <Wrench className="h-4 w-4 mr-1.5" /> Fix this stop
      </Button>
    );
  }

  return (
    <div className="mt-3 rounded-xl border border-border bg-secondary/40 p-3 space-y-2" data-testid={`fix-stop-panel-${id}`}>
      <div className="text-[11px] uppercase tracking-wider font-semibold text-muted-foreground">Fix this stop</div>
      <Button
        onClick={() => { setOpen(false); onDeliver(stop); }}
        className="w-full h-11 rounded-full bg-accent hover:bg-accent/90 text-accent-foreground"
        data-testid={`fix-deliver-${id}`}
      >
        {delivered ? <Camera className="h-4 w-4 mr-1.5" /> : <CheckCircle2 className="h-4 w-4 mr-1.5" />}
        {delivered ? "Redo POD (photos, signature, comments)" : "Change to Delivered"}
      </Button>
      {delivered && (
        <Button
          onClick={() => { setOpen(false); onFail(stop); }}
          className="w-full h-11 rounded-full bg-destructive hover:bg-destructive/90 text-destructive-foreground"
          data-testid={`fix-fail-${id}`}
        >
          <XCircle className="h-4 w-4 mr-1.5" /> Change to Failed
        </Button>
      )}
      <Button
        variant="outline"
        onClick={() => { setOpen(false); onReopen(stop); }}
        className="w-full h-11 rounded-full"
        data-testid={`fix-reopen-${id}`}
      >
        <RotateCcw className="h-4 w-4 mr-1.5" /> Reopen stop (move back to Pending)
      </Button>
      <Button variant="ghost" onClick={() => setOpen(false)} className="w-full h-9 rounded-full text-muted-foreground" data-testid={`fix-cancel-${id}`}>
        Cancel
      </Button>
    </div>
  );
}
